import React from 'react';
import { Box, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './CommonRoomResponsive.styles';
import CommonRoomContent from './CommonRoomContent';
import CommonRoomFeedResponsive from './CommonRoomFeedResponsive';
import CommonRoomSidebar from './CommonRoomSidebar';
import ScheduledPostsResponsive from './ScheduledPostsResponsive';
import type { CommonRoomView } from './types';

interface CommonRoomResponsiveProps {
  participantTotal?: number;
  spaceId?: string;
  view?: CommonRoomView;
}

const CommonRoomResponsive = ({
  participantTotal = 0,
  spaceId,
  view = 'feed',
}: CommonRoomResponsiveProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.root} data-testid="common-room-responsive">
      <CommonRoomSidebar
        participantTotal={participantTotal}
        spaceId={spaceId}
      />

      <CommonRoomContent
        label={
          view === 'scheduled'
            ? 'Scheduled posts content'
            : 'Common Room content'
        }
      >
        {view === 'scheduled' ? (
          <ScheduledPostsResponsive />
        ) : (
          <CommonRoomFeedResponsive />
        )}
      </CommonRoomContent>
    </Box>
  );
};

export default CommonRoomResponsive;
